<template>
  <div
    v-show="isLoading"
    class="loader-page duration-300"
    :class="{
      'page-enter-active': isLoading,
      'page-leave-active': !isLoading
    }"
  >
    <div
      wire:loading
      class="fixed inset-0 z-50 flex h-screen w-full flex-col items-center justify-center overflow-hidden bg-cdp-white opacity-80"
    >
      <img :src="loadingGif" class="mb-8" alt="loading..." />
      <p class="w-1/3 text-center text-xl text-cdp-main-primary-dark">讀取中請稍候 ...</p>
    </div>
  </div>
</template>

<script>
import loadingGif from '@/assets/loading.gif';

import { storeToRefs } from 'pinia';
import { userStore } from '@/stores/user.js';

export default {
  name: 'LoadingPage',
  setup() {
    const storeUser = userStore();
    const { isLoading } = storeToRefs(storeUser);

    return {
      loadingGif,
      isLoading
    };
  }
};
</script>